import './home.css';
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import PointsHistory from "../components/PointsHistory";
import PointsRules from "../components/PointsRules";
import WeeklyPointsArchive from "../components/WeeklyPointsArchive";
import api from "../api";
import { getLeaderboardRank } from "../utils/leaderboardUtils";
import { resolveMediaUrl } from "../utils/url";

export default function UserPointsHistory() {
  const { user } = useContext(UserContext);
  if (!user) return <div style={{padding:32}}>Nicht eingeloggt.</div>;
  const [points, setPoints] = useState({ lifetime: 0, weekly: 0 });
  const [badges, setBadges] = useState([]);
  const [lifetimeRank, setLifetimeRank] = useState(null);
  const [weeklyRank, setWeeklyRank] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!user?.id) return;
    (async () => {
      try {
        const res = await api.get('/users/me/points');
        if (!cancelled) {
          const p = res?.data || {};
          setPoints({ lifetime: Number(p.lifetime) || 0, weekly: Number(p.weekly) || 0 });
        }
      } catch {}
      try {
        const res = await api.get(`/badges/user/${user.id}`);
        if (!cancelled) setBadges(Array.isArray(res.data) ? res.data : []);
      } catch { if (!cancelled) setBadges([]); }
      try { const r = await getLeaderboardRank(user.id, 'lifetime'); if (!cancelled) setLifetimeRank(r); } catch {}
      try { const r = await getLeaderboardRank(user.id, 'weekly'); if (!cancelled) setWeeklyRank(r); } catch {}
    })();
    return () => { cancelled = true; };
  }, [user?.id]);
  return (
      <div style={{width:'100vw', margin:0, padding:0, display:'flex', justifyContent:'center'}}>
        <div className="home-page" style={{padding:32, maxWidth:700, width:'100%'}}>
          {/* Hero */}
          <section
            id="top"
            className={user ? 'hero-offset-if-sidebar' : ''}
            style={{
              width: '100vw',
              marginTop: 0,
              marginBottom: 0,
              padding: 0,
              marginLeft: 'calc(50% - 50vw)',
              marginRight: 'calc(50% - 50vw)',
            }}
          >
            <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Meine Punkte</h2>
            <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Regeln, aktuelle Werte und deine Punktehistorie – inkl. Filter und Export.</p>
          </section>
          <PointsRules />
          <hr style={{margin:'28px 0'}} />
          <CurrentPointsPanel points={points} badges={badges} lifetimeRank={lifetimeRank} weeklyRank={weeklyRank} />
          <hr style={{margin:'28px 0'}} />
          <PointsHistory />
        </div>
      </div>
  );
}

function CurrentPointsPanel({ points, badges, lifetimeRank, weeklyRank }) {
  return (
    <section style={{ width:'100%', margin:0, padding:0 }}>
      <div className="highlight-card" style={{ padding:20, display:'flex', flexDirection:'column', gap:10 }}>
        <h2 className="highlight-title" style={{ margin:0 }}>Aktuelle Punkte</h2>
        <div style={{ fontSize:16 }}>
          <span style={{marginRight:18}}>
            Lifetime‑Punkte: <span style={{color:'#32CD89', fontWeight:700}}>{points.lifetime}</span>
            {lifetimeRank === 1 && <span title="1. Platz" style={{marginLeft:8,fontSize:22}}>🥇</span>}
            {lifetimeRank === 2 && <span title="2. Platz" style={{marginLeft:8,fontSize:22}}>🥈</span>}
            {lifetimeRank === 3 && <span title="3. Platz" style={{marginLeft:8,fontSize:22}}>🥉</span>}
          </span>
          <span>
            Wöchentliche Punkte: <span style={{color:'#32CD89', fontWeight:700}}>{points.weekly}</span>
            {weeklyRank === 1 && <span title="1. Platz" style={{marginLeft:8,fontSize:22}}>🥇</span>}
            {weeklyRank === 2 && <span title="2. Platz" style={{marginLeft:8,fontSize:22}}>🥈</span>}
            {weeklyRank === 3 && <span title="3. Platz" style={{marginLeft:8,fontSize:22}}>🥉</span>}
          </span>
        </div>
        <div style={{marginTop:2}}>
          <span style={{fontWeight:600}}>Abzeichen:</span>{' '}
          {(!badges || badges.length === 0) ? <span style={{color:'#888'}}>Noch keine Abzeichen.</span> : (
            <span style={{display:'inline-flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
              {[...badges]
                .filter(ub => ub && ub.Badge)
                .sort((a, b) => (a.Badge?.sortIndex ?? 100) - (b.Badge?.sortIndex ?? 100))
                .slice(0,6)
                .map(ub => {
                  const levels = Array.isArray(ub.Badge?.BadgeLevels) ? ub.Badge.BadgeLevels : [];
                  let userLevel = null;
                  if (ub.note && ub.note.startsWith('Level ')) {
                    const lvlNum = parseInt(ub.note.replace('Level ', ''), 10);
                    userLevel = levels.find(l => l.level === lvlNum) || null;
                  }
                  const icon = resolveMediaUrl((userLevel && userLevel.icon) || ub.Badge.icon);
                  const title = (userLevel?.description) || ub.Badge.name;
                  return (
                    <img key={ub.id} src={icon} alt={ub.Badge.name} title={title} style={{width:24, height:24}} />
                  );
                })}
              {badges.length > 6 && <span style={{opacity:.8}}>+{badges.length - 6} weitere</span>}
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
